import { Box, BoxProps, CheckBox, Spacer, Text, TextProps } from '@jfs/ui-new'

interface TitleProps {
  text: string
  checked: boolean
  onChange: any
  fieldName?: string
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
}

export const AepsCheckBox = (props: TitleProps) => {
  const { alignItems } = props;
  return (
    <Box {...styles.container} alignItems={alignItems}>
      <Box mt={2}>
        <CheckBox
          checked={props?.checked}
          //onChecked={(isChecked) => props?.onChange(props?.fieldName ? isChecked + '' : isChecked)}
          alignBox="flex-start"
          iconSize={20}
          color={'PRIMARY_STORNG'}
          {...props}
        />
      </Box>
      <Spacer size={16} direction="horizontal" />
      <Text {...styles.title}>{props?.text}</Text>
    </Box>
  )
}

const styles = {
  container: {
    flexDirection: 'row',
  } as BoxProps,
  title: {
    fontFamily: 'jioType-medium',
    fontSize: 12,
    lineHeight: 18,
    color: 'BRAND_COLOR_GRAY_2',
  } as TextProps,
}
